<template>
  <v-dialog v-model="visible" max-width="520">
    <v-card>
      <v-card-title class="d-flex justify-center text-h6">外部連結提醒</v-card-title>
      <v-card-text class="text-body-1 text--primary pt-6">
        <v-icon size="22" color="warning">mdi-alert-outline</v-icon>
        <span class="orange--text text--darken-2 ml-1">您即將前往外部網站：</span>
        <br />
        <div class="grey lighten-4 pa-2 mt-2 rounded text-truncate">{{ url }}</div>
        <div class="mt-3">此連結非本服務所有，內容與隱私由該網站負責。請自行評估風險。</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">取消</v-btn>
        <v-btn color="primary" depressed @click="proceed">繼續前往</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ExternalLinkDialog",
  computed: {
    visible: {
      get() {
        return this.$store.state.externalLink.show;
      },
      set(v) {
        if (!v) this.$store.dispatch("externalLink/cancel");
      },
    },
    url() {
      return this.$store.state.externalLink.url;
    },
  },
  methods: {
    proceed() {
      this.$store.dispatch("externalLink/proceed");
    },
    cancel() {
      this.$store.dispatch("externalLink/cancel");
    },
  },
};
</script>
